import { render, staticRenderFns } from "./style.vue?vue&type=template&id=6a1dc15a&scoped=true"
import script from "./style.vue?vue&type=script&lang=js"
export * from "./style.vue?vue&type=script&lang=js"
import style0 from "./style.vue?vue&type=style&index=0&id=6a1dc15a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1dc15a",
  null
  
)

export default component.exports